exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-select{width:100%}#form-employee{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-1a3e4966!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/SelectEmployee.vue
// module id = 236
// module chunks = 0